import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';

export const paymentRedirectGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {
  const redirectKey = localStorage.getItem('redirectProductKey');
  const router = inject(Router);

  switch (redirectKey) {
    case 'generate-cv-pdf': 
      return router.createUrlTree(['/cv-review']);
    case 'generate-cv-word':
      return router.createUrlTree(['/cv-review']);
    case 'optimize-linkedin':
      return router.createUrlTree(['/create-linkedin-profile']);
    case 'generate-cover-letter':
      return router.createUrlTree(['/create-cover-letter']);
    case 'test-service':
      return router.createUrlTree(['/']);
    default:
      return true;
  }
};
